import React from 'react';
import partial from 'lodash/partial';

import DropDown from '../DropDown';
import NotificationList from '../NotificationList';

import * as styles from './styles.module.css';

const NotificationPanel = ({ setPanelOpen, onNotificationClick }) => {
  return (
    <DropDown
      className={styles.listContainer}
      onClose={partial(setPanelOpen, false)}
    >
      <NotificationList onNotificationClick={onNotificationClick} />
    </DropDown>
  );
};

export default NotificationPanel;
